<template>
  <div class="">
    <div class="update-adaptive-game-parent-MCQ-dropdown" :class="{'background-color-grey': activeRowCountIndexValue !== currComponentIndexValue }">
      <div class="row padding-top-15px">
        <div class="container-fluid">  
          <div class="col-md-4 col-lg-4">
            <div class="form-group col-md-10 col-lg-10 padding-left-0px">
              <select class="form-control" v-model="currSelectedMcqObjValue">
                <option value=-1 disabled>Select</option>
                <option v-for="currMcqObj in getMcqList" :key="currMcqObj.ElementId" :value="currMcqObj" :disabled="show(currMcqObj)">{{currMcqObj.Title}}</option>
              </select>
            </div>  
          </div>
          <div class="col-md-8 col-lg-8"></div>
        </div>
      </div>
      <div class="row padding-top-15px" v-if="currSelectedMcqObjValue !== -1">
        <div class="col-md-12 col-lg-12">
          <mcq-video-post-element-adaptive-game-dropdown v-for="(currOptionObj,index) in currentlySelectedMcqOptionList" :key="currOptionObj.optionId" :overallList="getOverallList" :currSelectedMcqObj="currSelectedMcqObjValue" :currOptionObj="currOptionObj" :currOptionIndex="index" @currOptionObj="updateOptionObj" :currActivatedRow="currActivatedRow" :gameLevelObj="gameLevelObjValue"></mcq-video-post-element-adaptive-game-dropdown>
        </div>
      </div>  
      <div class="row margin-bottom-2Perc margin-top-2Perc">  
        <div class="col-md-1 col-lg-1">
        </div>
        <div class="col-md-2 col-md-offset-4 col-lg-2 col-lg-offset-4" v-if="(currComponentIndexValue !== (getMcqList.length - 1)) && (activeRowCountIndexValue === currComponentIndexValue)">
          <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="performOperation($event, 'add')">Next</button>
        </div>
        <div class="col-md-2 col-md-offset-4 col-lg-2 col-lg-offset-4" v-if="currComponentIndexValue === (getMcqList.length - 1) && (activeRowCountIndexValue === currComponentIndexValue)">
          <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="performOperation($event, 'create')">Create</button>
        </div>  
        <div class="col-md-1 col-lg-1">
        </div>
        <div class="col-md-4 col-lg-4">
        </div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>
</template>

<script>
import map from 'lodash/map'
import findIndex from 'lodash/findIndex'
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import AddMcqAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddMcqAdaptiveGame'
import AddVideosAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddVideosAdaptiveGame'
import AddPostElementsAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddPostElementsAdaptiveGame'
import McqVideoPostElementAdaptiveGameDropdown from '@/components/adaptive_game/Update-element/UpdateMcqVideoPostElementAdaptiveGameDropdown'
export default {
  props: ['overallList', 'currComponentIndex', 'activeRowCountIndex', 'gameLevelObj'],
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      currSelectedMcqObj: -1,
      levelObj: {
        MCQElementId: '',
        Associations: []
      },
      currActivatedRow: 0
    }
  },
  name: 'update-adaptive-game-parent-MCQ-dropdown',
  methods: {
    show: function (currMcq) {
      const MCQElementIds = map(this.gameLevelObjValue, 'MCQElementId')
      // console.log('*** MCQElementId:', MCQElementIds)
      var currMcqElementId = currMcq.ElementId
      // console.log('** currMcqElementId:', currMcqElementId)
      return MCQElementIds.indexOf(currMcqElementId) > -1
    },
    performOperation: function (event, selectedOperation) {
      if (this.currSelectedMcqObjValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one mcq to create the adaptive game.'
        return
      }
      if (this.currActivatedRow < this.currentlySelectedMcqOptionList.length) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter data for all the options of \'' + this.currSelectedMcqObjValue.Title + '\' first.'
        return
      }
      switch (selectedOperation) {
        case 'add':
          var objToPass = {
            currComponentIndex: this.currComponentIndexValue,
            levelObject: this.levelObj,
            selectedOperation: selectedOperation
          }
          this.$emit('currParentMcqObj', objToPass)
          break
        case 'create':
          objToPass = {
            currComponentIndex: this.currComponentIndexValue,
            levelObject: this.levelObj,
            selectedOperation: selectedOperation
          }
          this.$emit('currParentMcqObj', objToPass)
          break
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateOptionObj (value) {
      var currOptionIndex = parseInt(value.currOptionIndex)
      var currOptionObj = value.currOptionObj
      var firstDDId = value.firstDDId
      var firstDDValue = value.firstDDValue
      var secondDDId = value.secondDDId
      var secondDDValue = value.secondDDValue
      console.log('secondDDValue >>> ' + JSON.stringify(secondDDValue))
      // console.log('Activate all options below or equal to ' + (currOptionIndex + 1) + firstDDId + '  ' + secondDDId)
      // console.log('Adding firstObj in levelObj >>> ', JSON.stringify(firstDDValue))
      var firstObj = {
        'Type': 'MCQOption',
        'FirstDDId': firstDDId,
        'ObjectId': currOptionObj.OptionId,
        'ToElementId': firstDDValue.ElementId
      }
      var currSelectedFirstArrIndex = findIndex(this.levelObj.Associations, function (o) {
        // console.log('o.FirstDDId >>> ' + o.FirstDDId + ' firstDDId >>>> ' + firstDDId)
        return ((o.FirstDDId === firstDDId) && (o.Type === 'MCQOption'))
      })
      console.log('currSelectedFirstArrIndex >> ' + this.currSelectedFirstArrIndex)
      if (currSelectedFirstArrIndex !== -1 && currSelectedFirstArrIndex !== undefined && parseInt(firstDDValue) !== -1) {
        // console.log('Updated Obj >>>')
        this.levelObj.Associations[currSelectedFirstArrIndex] = firstObj
      } else {
        // console.log('New Obj Pushed >>>')
        this.levelObj.Associations.push(firstObj)
      }
      if (parseInt(secondDDValue) === -1) {
        console.log('Second DD value is -1 or it\'t disabled')
      } else {
        // console.log('Adding secondObj in levelObj >>> ', JSON.stringify(secondDDValue))
        var secondObj = {
          'Type': 'Video',
          'SecondDDId': secondDDId,
          'ObjectId': firstDDValue.ElementId,
          'ToElementId': secondDDValue.ElementId
        }
        var currSelectedSecondArrIndex = findIndex(this.levelObj.Associations, function (o) {
          // console.log('o.SecondDDId >>> ' + o.SecondDDId + ' SecondDDId >>>> ' + secondDDId)
          return ((o.SecondDDId === secondDDId) && (o.Type === 'Video'))
        })
        console.log('currSelectedSecondArrIndex >> ' + this.currSelectedSecondArrIndex)
        if (currSelectedSecondArrIndex !== -1 && currSelectedSecondArrIndex !== undefined && parseInt(secondDDValue) !== -1) {
          console.log('this.levelObj.Associations[currSelectedSecondArrIndex] >>> ' + JSON.stringify(this.levelObj.Associations[currSelectedSecondArrIndex]))
          console.log('secondObj >>> ' + JSON.stringify(secondObj))
          this.levelObj.Associations[currSelectedSecondArrIndex] = secondObj
        } else {
          this.levelObj.Associations.push(secondObj)
        }
      }
      var currOptionIndexValue = parseInt((currOptionIndex + 1))
      if (this.currActivatedRow < currOptionIndexValue) {
        this.currActivatedRow = currOptionIndexValue
      } else if (this.currActivatedRow > currOptionIndex) {
        this.currActivatedRow = this.currActivatedRow
      } else {
        this.currActivatedRow = currOptionIndex
      }
      console.log('this.currActivatedRow <<<< ' + this.currActivatedRow)
      console.log('currOptionIndex <<<< ' + currOptionIndex)
      console.log('levelObj <<<< ' + JSON.stringify(this.levelObj))
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'add-mcq-adaptive-game': AddMcqAdaptiveGame,
    'add-videos-adaptive-game': AddVideosAdaptiveGame,
    'add-post-elements-adaptive-game': AddPostElementsAdaptiveGame,
    'mcq-video-post-element-adaptive-game-dropdown': McqVideoPostElementAdaptiveGameDropdown
  },
  computed: {
    gameLevelObjValue: {
      get: function () {
        return this.gameLevelObj
      }
    },
    activeRowCountIndexValue: {
      get: function () {
        return this.activeRowCountIndex
      }
    },
    currComponentIndexValue: {
      get: function () {
        return this.currComponentIndex
      }
    },
    getOverallList: {
      get: function () {
        return this.overallList
      }
    },
    getMcqList: {
      get: function () {
        return this.overallList.currentMcqList
      }
    },
    getVideoList: {
      get: function () {
        return this.overallList.currentVideoList
      }
    },
    getPostElementList: {
      get: function () {
        return this.overallList.currentPostList
      }
    },
    currSelectedMcqObjValue: {
      get: function () {
        return this.currSelectedMcqObj
      },
      set: function (newValue) {
        // console.log('currSelectedMcqObjValue >>> ' + JSON.stringify(newValue))
        this.levelObj.MCQElementId = newValue.ElementId
        this.currActivatedRow = 0
        this.currSelectedMcqObj = newValue
      }
    },
    currentlySelectedMcqOptionList: {
      get: function () {
        return this.currSelectedMcqObjValue.MCQItem.Options
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.background-color-grey {
  /* background: #ccc; */
  pointer-events: none;
  background-color: #eee;
  opacity: 0.6;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.padding-right-3em {
    padding-right:3em;
}
.font-size-17px {
  font-size:17px;
}
.border-1px {
  border-right: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-left: 1px solid #aaa;
  border-top: 0px solid #aaa;
}
.padding-top-15px {
  padding-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameParentMCQDropdown.vue